import s from './Header.module.scss';
import { ReactComponent as Logo } from '../../../aassets/img/adaptor-logo.svg';
import Menu from '../Menu/Menu';
import { ReactPressVars } from '../../../types';
import { Link } from 'react-router-dom';
interface Props {
    root: HTMLElement;
    wpdata: ReactPressVars;
}
const Header = ({ root, wpdata }: Props) => {
    return (
        <header className={s.root}>
            <Menu root={root} wpdata={wpdata} />
            <Link to="/">
                <Logo title="אדפטור לוגו" />
            </Link>
        </header>
    );
};
export default Header;
